import { Link } from "react-router"
import { useAdminStore } from "@/shared/hooks/use-admin-store"
import styles from "./admin-header.module.css"

export function AdminHeader() {
  const { admin, logout } = useAdminStore()

  return (
    <header className={styles.header}>
      <div className={styles.search}>
        <span className={styles.searchIcon}>🔍</span>
        <input type="text" placeholder="搜索用户、任务、内容..." />
        <kbd className={styles.shortcut}>⌘K</kbd>
      </div>
      <div className={styles.actions}>
        <button className={styles.iconBtn} title="通知">
          <span>🔔</span>
          <span className={styles.notificationDot} />
        </button>
        <button className={styles.iconBtn} title="消息">
          <span>💬</span>
        </button>
        <div className={styles.divider} />
        <div className={styles.userMenu}>
          <button className={styles.userBtn} onClick={logout}>
            <span className={styles.avatar}>
              {admin?.nickname?.[0]?.toUpperCase() || "A"}
            </span>
            <span className={styles.userInfo}>
              <span className={styles.nickname}>{admin?.nickname || "管理员"}</span>
              <span className={styles.role}>{admin?.role === "super_admin" ? "超级管理员" : "管理员"}</span>
            </span>
            <span className={styles.arrow}>▼</span>
          </button>
        </div>
      </div>
    </header>
  )
}